import type {
  LazyQueryHookOptions,
  OperationVariables,
  TypedDocumentNode,
} from '@apollo/client';
import {
  // eslint-disable-next-line no-restricted-imports
  useLazyQuery as apolloUseLazyQuery,
} from '@apollo/client/react';

type ApolloTuple<TData, TVariables extends OperationVariables> = ReturnType<
  typeof apolloUseLazyQuery<TData, TVariables>
>;

export type LazyQueryExecFunction<
  TData,
  TVariables extends OperationVariables,
> = ApolloTuple<TData, TVariables>[0];

export type CompleteLazyResult<
  TData,
  TVariables extends OperationVariables,
> = ApolloTuple<TData, TVariables>[1];

export const useLazyQuery = <TData, TVariables extends OperationVariables>(
  query: TypedDocumentNode<TData, TVariables>,
  options?: LazyQueryHookOptions<NoInfer<TData>, NoInfer<TVariables>>
): [
  LazyQueryExecFunction<TData, TVariables>,
  CompleteLazyResult<TData, TVariables>,
] => apolloUseLazyQuery(query, options);
